<app-waves-background />

<app-dashboard-layout [routerPath]="(routerPath$ | async) ?? ''" >
  <div class="flex flex-col gap-3 px-6 pt-4">
    <zaeper-payment-standing-banner
      [standing]="standing()"
      [isAdmin]="isAdmin()"
      [language]="language()"
      [busy]="openingPortal()"
      (addPaymentMethod)="openPaymentPortal()"
    ></zaeper-payment-standing-banner>
    <zaeper-mfa-reminder-banner
      [mfaEnabled]="mfaEnabled()"
      (actionClicked)="goToMfaSettings()"
    ></zaeper-mfa-reminder-banner>
  </div>
  <router-outlet></router-outlet>
</app-dashboard-layout>

<zaeper-toast />
